// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"0035b59aa8cac867f843","453":"b99da53e0001890a441f","522":"c77c168f5f718d437720"}[chunkId] + ".js";
};